'use client'
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/layout';
import { Button, FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/system';
import useExperienceApi from '../../../experiences/lib/useExperienceApi';
import useTranslation from '../../../lib/i18n/useTranslation';
const NewExperienceGroupInPersonaForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    personaId,
    groupId
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting,  isValid }
  } = useForm();
  const experienceApi = useExperienceApi();
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      if (name) {
        const result = await experienceApi.insertExperienceGroupInPersona(
          name,
          personaId,
          groupId
        );
      }
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error('❌ DEBUG: newExperienceGroupInPersonaForm onSubmit error:', e);
    }
  };
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <FormControl isInvalid={errors && errors.name} mb={3}>
            <FormLabel>{t('group.groupName')}</FormLabel>
            <Input
              placeholder={t('group.groupNamePlaceholder')}
              {...register('name', {
                required: true,
                minLength: 3
              })}
            />
            <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
          </FormControl>
          <Button
            style={{
              display: hideSave ? 'none' : 'inherit',
            }}
            ref={ref}
            isLoading={isSubmitting}
            isDisabled={!isValid}
            type='submit'
            my={2}
          >Save</Button>
        </form>
      </Box>
    </>
  );
});
export default NewExperienceGroupInPersonaForm;
